import {takeLatest, call, put} from 'redux-saga/effects';
import {getSpecialistProfileRequest} from '../slices/authSlice';
import {
  // get consultation summary api
  getConsultationSummaryRequest,
  getConsultationSummarySuccess,
  getConsultationSummaryFailure,

  // get specialist dashboard stats api
  specialistDashboardStatsRequest,
  specialistDashboardStatsSuccess,
  specialistDashboardStatsFailure,

  // get specialist consultations api
  getSpecialistConsultationsRequest,
  getSpecialistConsultationsSuccess,
  getSpecialistConsultationsFailure,

  // get patient details api
  getPatientDetailsRequest,
  getPatientDetailsSuccess,
  getPatientDetailsFailure,

  // updated consultation summary api
  updateConsultationSummaryRequest,
  updateConsultationSummarySuccess,
  updateConsultationSummaryFailure,

  // upload specialist consultation additional documents api
  uploadSpecialistConsultationAdditionalFilesRequest,
  uploadSpecialistConsultationAdditionalFilesSuccess,
  uploadSpecialistConsultationAdditionalFilesFailure,

  // remove specialist additional documents
  removeSpecialistConsultationAdditionalFilesFailure,
  removeSpecialistConsultationAdditionalFilesRequest,
  removeSpecialistConsultationAdditionalFilesSuccess,

  // get specialist list for refferal api
  getSpecialistListForRefferalRequest,
  getSpecialistListForRefferalSuccess,
  getSpecialistListForRefferalFailure,

  // get specialist payments api
  getSpecialistPaymentsRequest,
  getSpecialistPaymentsSuccess,
  getSpecialistPaymentsFailure,

  // remove license api
  removeLicenseRequest,
  removeLicenseSuccess,
  removeLicenseFailure,
  // remove signature api
  removeSignatureRequest,
  removeSignatureSuccess,
  removeSignatureFailure,

  // Speech to Text
  transcribeAudioFailure,
  transcribeAudioRequest,
  transcribeAudioSuccess,
} from '../slices/specialistDashboardSlice';
import {
  getConsultationSummary,
  getSpecialistDashboardStats,
  getSpecialistConsultations,
  getPatientDetails,
  updateConsultationSummary,
  uploadSpecialistConsultationAdditionalDocuments,
  removeSpecialistConsultationAdditionalDocuments,
  specialistListForRefferal,
  getSpecialistPayments,
  removeLicense,
  removeSignature,
  transcribeAudio,
} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* GetConsultationSummarySaga(action: any): Generator {
  try {
    const response: any = yield call(getConsultationSummary, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getConsultationSummarySuccess(response.data));
    } else {
      yield put(getConsultationSummaryFailure(response.data));
    }
  } catch (error: any) {
    yield put(getConsultationSummaryFailure(error.response));
  }
}

function* SpecialistDashboardStatsSaga(): Generator {
  try {
    const response: any = yield call(getSpecialistDashboardStats);
    if (response.data.status === SUCCESS_KEY) {
      yield put(specialistDashboardStatsSuccess(response.data));
    } else {
      yield put(specialistDashboardStatsFailure(response.data));
    }
  } catch (error: any) {
    yield put(specialistDashboardStatsFailure(error.response));
  }
}

function* GetSpecialistConsultationsSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistConsultations, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistConsultationsSuccess(response.data));
    } else {
      yield put(getSpecialistConsultationsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistConsultationsFailure(error.response));
  }
}

function* GetPatientDetailsSaga(action: any): Generator {
  try {
    const response: any = yield call(getPatientDetails, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getPatientDetailsSuccess(response.data));
    } else {
      yield put(getPatientDetailsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getPatientDetailsFailure(error.response));
  }
}

function* UpdateConsultationSummarySaga(action: any): Generator {
  try {
    const response: any = yield call(updateConsultationSummary, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateConsultationSummarySuccess(response.data));
    } else {
      yield put(updateConsultationSummaryFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateConsultationSummaryFailure(error.response));
  }
}

function* UploadConsultationAdditionalFilesSaga(action: any): Generator {
  try {
    const response: any = yield call(uploadSpecialistConsultationAdditionalDocuments, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(uploadSpecialistConsultationAdditionalFilesSuccess(response.data));
    } else {
      yield put(uploadSpecialistConsultationAdditionalFilesFailure(response.data));
    }
  } catch (error: any) {
    yield put(uploadSpecialistConsultationAdditionalFilesFailure(error.response));
  }
}

function* RemoveConsultationAdditionalFilesSaga(action: any): Generator {
  try {
    const response: any = yield call(removeSpecialistConsultationAdditionalDocuments, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(removeSpecialistConsultationAdditionalFilesSuccess(response.data));
    } else {
      yield put(removeSpecialistConsultationAdditionalFilesFailure(response.data));
    }
  } catch (error: any) {
    yield put(removeSpecialistConsultationAdditionalFilesFailure(error.response));
  }
}

function* GetSpecialistListForRefferalSaga(action: any): Generator {
  try {
    const response: any = yield call(specialistListForRefferal, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistListForRefferalSuccess(response.data));
    } else {
      yield put(getSpecialistListForRefferalFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistListForRefferalFailure(error.response));
  }
}

function* GetSpecialistPaymentsSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistPayments, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistPaymentsSuccess(response.data));
    } else {
      yield put(getSpecialistPaymentsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistPaymentsFailure(error.response?.data || error.response));
  }
}

function* RemoveLicenseSaga(): Generator {
  try {
    const response: any = yield call(removeLicense);
    if (response.data.status === SUCCESS_KEY) {
      yield put(removeLicenseSuccess(response.data));
      // Delay refetch to allow toast to be displayed first
      yield new Promise(resolve => setTimeout(resolve, 100));
      // Refetch specialist profile data to get updated details
      yield put(getSpecialistProfileRequest());
    } else {
      yield put(removeLicenseFailure(response.data));
    }
  } catch (error: any) {
    yield put(removeLicenseFailure(error.response?.data || error.response || {status: 'error', status_code: 'E-10001'}));
  }
}

function* RemoveSignatureSaga(): Generator {
  try {
    const response: any = yield call(removeSignature);
    if (response.data.status === SUCCESS_KEY) {
      yield put(removeSignatureSuccess(response.data));
      // Delay refetch to allow toast to be displayed first
      yield new Promise(resolve => setTimeout(resolve, 100));
      // Refetch specialist profile data to get updated details
      yield put(getSpecialistProfileRequest());
    } else {
      yield put(removeSignatureFailure(response.data));
    }
  } catch (error: any) {
    yield put(removeSignatureFailure(error.response?.data || error.response || {status: 'error', status_code: 'E-10001'}));
  }
}

// Speech to Text
function* TranscribeAudioSaga(action: any): Generator {
  try {
    const response: any = yield call(transcribeAudio, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(transcribeAudioSuccess(response.data));
    } else {
      yield put(transcribeAudioFailure(response.data));
    }
  } catch (error: any) {
    yield put(transcribeAudioFailure(error?.response?.data ?? {status_code: 'E-NETWORK'}));
  }
}

export default function* specialistDashboardSaga(): Generator {
  yield takeLatest(getConsultationSummaryRequest.type, GetConsultationSummarySaga);
  yield takeLatest(specialistDashboardStatsRequest.type, SpecialistDashboardStatsSaga);
  yield takeLatest(getSpecialistConsultationsRequest.type, GetSpecialistConsultationsSaga);
  yield takeLatest(getPatientDetailsRequest.type, GetPatientDetailsSaga);
  yield takeLatest(updateConsultationSummaryRequest.type, UpdateConsultationSummarySaga);
  yield takeLatest(uploadSpecialistConsultationAdditionalFilesRequest.type, UploadConsultationAdditionalFilesSaga);
  yield takeLatest(removeSpecialistConsultationAdditionalFilesRequest.type, RemoveConsultationAdditionalFilesSaga);
  yield takeLatest(getSpecialistListForRefferalRequest.type, GetSpecialistListForRefferalSaga);
  yield takeLatest(getSpecialistPaymentsRequest.type, GetSpecialistPaymentsSaga);
  yield takeLatest(removeLicenseRequest.type, RemoveLicenseSaga);
  yield takeLatest(removeSignatureRequest.type, RemoveSignatureSaga);
  yield takeLatest(transcribeAudioRequest.type, TranscribeAudioSaga);
}
